<div class="flex justify-between items-center bg-gray-100 rounded p-3">
  <div
    class="p-2 rounded-2xl bg-gray-200"
    (click)="previous()"
  >
    <app-icon
      path="assets/icons/caret-left-bold.svg"
      color="rgb(55,65,81)"
      [width]="18"
      [height]="18"
    />
  </div>

  <div class="flex flex-col justify-center items-center text-md font-medium text-gray-600">
    <span>{{ label() }}</span>
  </div>

  <div
    class="p-2 rounded-2xl bg-gray-200"
    (click)="next()"
  >
    <app-icon
      path="assets/icons/caret-right-bold.svg"
      color="rgb(55,65,81)"
      [width]="18"
      [height]="18"
    />
  </div>
</div>
